import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-biometric-info',
  templateUrl: './update-biometric-info.component.html',
  styleUrls: ['./update-biometric-info.component.css']
})
export class UpdateBiometricInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
